import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageMeta from "@/components/feature/PageMeta";
import ArticleCard from "@/components/feature/ArticleCard";
import { categories, getFeaturedArticles, getLatestArticles } from "@/mocks/data";

export default function Home() {
  const featuredArticles = getFeaturedArticles();
  const latestArticles = getLatestArticles();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "免费91网页",
    url: "https://www.91web.com",
    description:
      "免费91网页为您提供便捷的在线网页服务，无需注册即可免费使用91网页全部功能，快速访问、流畅体验，是您日常上网冲浪的最佳选择。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.91web.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <PageMeta
        title="免费91网页-立即免费访问91网页平台"
        description="免费91网页为您提供便捷的在线网页服务，无需注册即可免费使用91网页全部功能，快速访问、流畅体验，是您日常上网冲浪的最佳选择，立即打开免费91网页开始体验。"
        keywords="免费91 网页,91网页免费入口,免费91网页在线访问,91网页免费使用,免费91网页最新地址,91免费网页平台,免费网页91入口"
        canonicalUrl="https://www.91web.com"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20clean%20web%20portal%20homepage%20design%20with%20warm%20minimal%20aesthetic%2C%20digital%20content%20platform%20concept%2C%20soft%20neutral%20background&width=1200&height=630&seq=home-og&orientation=landscape"
      />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[550px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimal%20abstract%20geometric%20background%20with%20soft%20gradients%20in%20warm%20neutral%20tones%2C%20clean%20modern%20design%2C%20digital%20platform%20atmosphere%2C%20subtle%20texture%2C%20professional%20web%20portal%20background&width=1600&height=550&seq=home-hero&orientation=landscape"
              alt="免费91网页 - 您的在线内容平台"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
            <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
              <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 max-w-3xl leading-tight">
                免费91网页 - 您的在线内容平台
              </h1>
              <p className="text-base md:text-lg text-white/90 max-w-2xl mb-8">
                无需注册，即刻访问。科技、生活、娱乐、教育、健康等多元内容一网打尽，为您开启精彩的在线阅读之旅。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/category/keji-shuma"
                  className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  开始探索
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 bg-white/20 text-white rounded-full font-medium text-sm hover:bg-white/30 transition-colors whitespace-nowrap backdrop-blur-sm"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Categories Grid */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                探索内容分类
              </h2>
              <p className="text-foreground-600 max-w-xl mx-auto">
                五大内容板块，覆盖您感兴趣的所有领域，随时随地免费畅读
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center p-6 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors text-center"
                >
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className={`${cat.icon} text-2xl`}></i>
                  </div>
                  <h3 className="text-foreground-950 font-semibold text-sm mb-1 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500">
                    {cat.articleCount}篇文章
                  </p>
                </Link>
              ))}
            </div>
          </section>

          {/* Featured Articles */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                  精选推荐
                </h2>
                <p className="text-foreground-600 text-sm">
                  编辑团队为您精选的优质内容
                </p>
              </div>
              <Link
                to="/category/keji-shuma"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          {/* Latest Articles */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                  最新文章
                </h2>
                <p className="text-foreground-600 text-sm">
                  实时更新的最新内容，不错过任何精彩
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {latestArticles.slice(0, 8).map((article) => (
                <ArticleCard
                  key={article.id}
                  article={article}
                  variant="horizontal"
                />
              ))}
            </div>
            <div className="text-center mt-8">
              <Link
                to="/category/keji-shuma"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-700 hover:bg-background-200/70 transition-colors text-sm font-medium whitespace-nowrap"
              >
                加载更多文章
                <i className="ri-arrow-down-line"></i>
              </Link>
            </div>
          </section>

          {/* CTA Section */}
          <section className="relative w-full py-20 overflow-hidden mt-10">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20flowing%20shapes%20in%20earthy%20neutral%20tones%2C%20minimal%20modern%20design%2C%20inviting%20atmosphere%2C%20clean%20professional%20aesthetic&width=1600&height=400&seq=home-cta&orientation=landscape"
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/30"></div>
            <div className="relative z-10 max-w-3xl mx-auto text-center px-4">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
                即刻开启免费阅读体验
              </h2>
              <p className="text-white/90 mb-8 max-w-xl mx-auto">
                无需注册，无需付费，免费91网页为您提供全方位的内容服务。现在就加入我们，发现更多精彩内容。
              </p>
              <Link
                to="/category/yule-xiuxian"
                className="inline-block px-8 py-3 bg-accent-500 text-background-50 rounded-full font-medium text-sm hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                免费开始阅读
              </Link>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="max-w-3xl mx-auto px-4 md:px-6 py-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              常见问题
            </h2>
            <div className="space-y-4">
              {[
                {
                  q: "免费91网页真的完全免费吗？",
                  a: "是的，免费91网页所有内容完全免费，无需注册即可访问和阅读全部文章。我们致力于为用户提供无障碍的优质内容服务。",
                },
                {
                  q: "免费91网页有哪些内容分类？",
                  a: "我们目前涵盖科技数码、生活百科、娱乐休闲、教育学习和健康养生五大内容板块，每篇文章都经过精心编辑，确保内容质量和可读性。",
                },
                {
                  q: "如何快速找到感兴趣的内容？",
                  a: "您可以通过顶部导航栏的分类菜单浏览不同板块的内容，也可以在首页的精选推荐和最新文章中快速找到热门内容。",
                },
                {
                  q: "免费91网页可以在手机上访问吗？",
                  a: "当然可以！免费91网页采用响应式设计，完美适配手机、平板和电脑等各类设备，让您随时随地畅享阅读。",
                },
                {
                  q: "文章多久更新一次？",
                  a: "我们的编辑团队每天都会更新内容，确保您每天都能看到新鲜热门的文章。订阅我们的更新通知，不错过任何精彩。",
                },
              ].map((faq, index) => (
                <details
                  key={index}
                  className="group bg-background-100 rounded-lg overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-5 cursor-pointer text-foreground-950 font-medium text-sm">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-lg transition-transform group-open:rotate-180"></i>
                  </summary>
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>

            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "FAQPage",
                  mainEntity: [
                    {
                      "@type": "Question",
                      name: "免费91网页真的完全免费吗？",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "是的，免费91网页所有内容完全免费，无需注册即可访问和阅读全部文章。我们致力于为用户提供无障碍的优质内容服务。",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "免费91网页有哪些内容分类？",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "我们目前涵盖科技数码、生活百科、娱乐休闲、教育学习和健康养生五大内容板块，每篇文章都经过精心编辑，确保内容质量和可读性。",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "如何快速找到感兴趣的内容？",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "您可以通过顶部导航栏的分类菜单浏览不同板块的内容，也可以在首页的精选推荐和最新文章中快速找到热门内容。",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "免费91网页可以在手机上访问吗？",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "当然可以！免费91网页采用响应式设计，完美适配手机、平板和电脑等各类设备，让您随时随地畅享阅读。",
                      },
                    },
                    {
                      "@type": "Question",
                      name: "文章多久更新一次？",
                      acceptedAnswer: {
                        "@type": "Answer",
                        text: "我们的编辑团队每天都会更新内容，确保您每天都能看到新鲜热门的文章。订阅我们的更新通知，不错过任何精彩。",
                      },
                    },
                  ],
                }),
              }}
            />
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}